module.exports = __webpack_public_path__ + "static/theme-editor-credits-22bf6142eece9e4c246f4aa22bebddab.png";